import { render, staticRenderFns } from "./commentAudit.vue?vue&type=template&id=d6e9517e&scoped=true&"
import script from "./commentAudit.vue?vue&type=script&lang=js&"
export * from "./commentAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e9517e",
  null
  
)

export default component.exports